import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { GridsterItem, GridsterItemComponentInterface } from 'angular-gridster2';
import { WidgetEmb, WidgetConfigurationObj, VisionStep } from '@wizeoo/akm-message-lib';
import { FreeDataVO } from '../../vo/core/freedata.vo';
import { ViewData } from '../../model/view.data';
import { Model } from '../../model/model';
import { BaselineEngine, VisionVO, WizConstants } from '@wizeoo/akm-compute-lib';
import { IWidget } from '../../manager/widgets/i-widget';

/**
 * un widget, compatible avec le contrat d'interface Gridster
 * contient le gridsterItem & la conf Allkeyme
 */
export class GridsterWidget implements GridsterItem {
  
  /** construction sur add depuis la vue template. Sinon, création depuis la conf json */
  public static constructFromGridster(model: Model, grit: GridsterItem): GridsterWidget {
    const result: GridsterWidget = new GridsterWidget(model); 
    // console.log('GridsterWidget constructFromGridster (add sur templating', grit.x, grit.y, grit.rows, grit.cols);
    result.feedCoords(grit.x, grit.y, grit.rows, grit.cols);
    return result;
  }

  public model: Model;

  public compo: GridsterItemComponentInterface = null;

  // emplacement RIGHT, LEFT... null par défaut
  public place: string = null;

  /**
   * constructeur. Si existe, alimentation de la partie "Gridster" depuis le widget
   * @param widget 
   */
  constructor(model: Model, widget?: WidgetEmb) {
    this.model = model;
    if (widget != null) {
      // console.log('GridsterWidget constructor', widget.x, widget.y, widget.rows, widget.cols);
      this.source = widget;
      this.x = widget.x;
      this.y = widget.y;

    // if(!!widget.wco.hidden) {
    //       console.log('GridsterWidget hidden', widget.wco, this);
    //       this.x = -1;
    //       this.y = -1;
    //       this.cols = 0;
    //       this.rows = 0;  
    // } else {
      this.cols = widget.cols;
      this.rows = widget.rows;
    // }


    } else {
      this.source = new WidgetEmb();
      this.source.uid = WizMathUtils.createUUID();
      this.isFake = true;
    }
  }

  /** alimentation des coordonnées (sur create) */
  public feedCoords( x: number, y: number, rows: number, cols: number): void {
    this.source.x = x;
    this.source.y = y;
    this.source.cols = cols;
    this.source.rows = rows;
    this.x = x;
    this.y = y;

    // if(!!this.source.wco.hidden) {
    //       console.log('GridsterWidget hidden', this.source.wco, this);
    //       this.x = -1;
    //       this.y = -1;
    //       this.cols = 0;
    //       this.rows = 0;  
    // } else {
    //   // this.cols = widget.cols;
    //   // this.rows = widget.rows;
    // }

    // console.log('feedCoords', this.source.wco, this);
    this.rows = rows;
    this.cols = cols;
  }

  /** alimentation des coordonnées du widget depuis les valeurs gridster (pas moyen de mettre en place getSet sur coords...) */
  public updateCoords(): void {
    this.source.x = this.x;
    this.source.y = this.y;
    
    this.source.cols = this.cols;
    this.source.rows = this.rows;
  }


  /** la configuration encapsulée */
  public source: WidgetEmb;

  /** 
   * l'instance physique lorsqu'elle est construite
   * alimentée par widgetComponent sur sa phase de création
   */
  public instance: IWidget;


  /** en cours de création */
  public isFake: boolean = false;

  /** on a alimenté le wco sur le widget (y'a quelque chose de valable...) */
  public hasContent(): boolean {
    return !!this.source?.wco;
  }


  public get uid(): string {
    return this.source.uid;
  }

  public get masterUid(): string {
    return !!this.source.wco && this.source.wco.muid ? this.source.wco.muid : null;
  }
  public set masterUid(value: string) {
    if(!!this.source.wco) {
      this.source.wco.muid = value;
    }
  }

  x: number;
  y: number;
  rows: number;
  cols: number;

  public get indice(): number {
    return this.source.indice;
  }
  public set indice(value: number) {
    this.source.indice = value;
  }

  public get wco(): WidgetConfigurationObj {
    return this.source.wco; // as WidgetConfigurationObj;
  }
  public set wco(value: WidgetConfigurationObj) {
    this.source.wco = value;
  }

  /** type de widget pour identifier les globalFilters */
  public get kind(): string {
    return this.source.wco?.k;
  }
  public set kind(value: string) {
    if(!!this.source.wco) {
      this.source.wco.k = value;
    }
  }


  public get code(): string {
    return this.source.code;
  }
  public set code(value: string) {
    this.source.code = value;
  }

  public get title(): string {
    return this.source.title;
  }

  public set title(value: string) {
    this.source.title = value;
  }

  public get fontColor(): string {
    return this.source.fontColor;
  }

  public set fontColor(pValue: string) {
    this.source.fontColor = pValue;
  }

  public get iconColor(): string {
    return this.source.iconColor;
  }

  public set iconColor(pValue: string) {
    this.source.iconColor = pValue;
  }

  public get borderColor(): string {
    return this.source.wco?.borderColor;
  }

  public set borderColor(pValue: string) {
    this.source.wco.borderColor = pValue;
  }

  public get backgroundColor(): string {
    return this.source.backgroundColor;
  }

  public set backgroundColor(pValue: string) {
    this.source.backgroundColor = pValue;
  }

  public get hideBorders(): boolean {
    return this.source.hideBorders;
  }

  public set hideBorders(pValue: boolean) {
    this.source.hideBorders = pValue;
  }

  public get rowHeight(): number {
    return this.source.wco?.rowHeight || ViewData.defaultRowHeight;
  }

  public set rowHeight(pValue: number) {
    this.source.wco.rowHeight = pValue;
  }

  public get headerHeight(): number {
    return this.source.wco?.headerHeight || ViewData.defaultHeaderHeight;
  }

  public set headerHeight(pValue: number) {
    this.source.wco.headerHeight = pValue;
  }
  
  public get radius(): number {
    return this.source.wco?.radius || 0;
  }

  public set radius(pValue: number) {
    this.source.wco.radius = pValue;
  }

  public get widgetBackgroundColor(): string {
    return this.source.widgetBackgroundColor;
  }

  public set widgetBackgroundColor(pValue: string) {
    this.source.widgetBackgroundColor = pValue;
  }

  private _fontColorH: string = null;
  private _backgroundColorH: string = null;

  private generateColorH(): void {
    const styleParts: string[] = this.wco.hsty?.split(ViewData.KEY_SEPARATOR) || [];
    while(styleParts.length < 2) {
      styleParts.push(null);
    }
    
    if (!!styleParts[0]) {
      this._backgroundColorH = styleParts[0];
    }
    if (!!styleParts[1]) {
      this._fontColorH = styleParts[1];
    }
  }

  get fontColorH(): string {
    this.generateColorH();
    return this._fontColorH;
  }

  get backgroundColorH(): string {
    this.generateColorH();
    return this._backgroundColorH;
  }

  private generateHsty(color: string= null, index: number): void {
    const styleParts: string[] = this.wco.hsty?.split(ViewData.KEY_SEPARATOR) || [];
    while(styleParts.length < 2) {
      styleParts.push('unset');
    }
    styleParts[index] = color;
    this.wco.hsty = styleParts.join(WizConstants.KEY_SEPARATOR);
  }

  public set fontColorH(pValue: string) {
    this._fontColorH = pValue;
    this.generateHsty(pValue, 1);
  }

  public set backgroundColorH(pValue: string) {
    this._backgroundColorH = pValue;
    this.generateHsty(pValue, 0);
  }





  /** alimentation du titre par défaut sur choix */
  public get label(): string {
    if (!!this.title) {
      return this.title;
    } else {
      return this.model.widgetEngine.getDefaultTitle(this.wco);
    }
  }

  /** alimentation du titre avec numéro d'indice */
  public get labelAndIdx(): string {
    let result: string = this.indice.toString();
    if (!!this.title) {
      result += ' ' + this.title;
    } else {
      result += ' ' + this.model.widgetEngine.getDefaultTitle(this.wco);
    }
    return result;
  }

  /** coordonnées pour sort rapide sur un décimal */
  public get coords(): number {
    return Number(this.y + '.' + this.x);
  }

  /** retourne la vision */
  public get visionVO(): VisionVO {
    let vision: VisionVO = null;
    const visionCode: string = this.wco?.v;
    if(!!visionCode) {
      vision = this.model.visionEngine.getVision(visionCode);
    }
    
    return vision;
  }

  /** retourne le step */
  public get visionStep(): VisionStep {
    let step: VisionStep = null;
    if (!!this.visionVO && this.wco?.vs) {
      // visionStep défini
      step = BaselineEngine.getVisionStepByLevel(this.visionVO, Number(this.wco.vs));
      // this.visionVO.getVisionStepByLevel(Number(this.wco.vs));
    }
    return step;
  }

  /** retourne le maître GridsterItemVo en cas de servage */
  public get masterVO(): GridsterWidget {
    let result: GridsterWidget = null;
    if (this.masterUid) {
      result = this.model.widgetEngine.getWidgetByUid(this.masterUid);
    }
    return result;
  }

  /** accesseur sur le freeData pour gestion des droits */
  public get freedataVO(): FreeDataVO {
    let result: FreeDataVO = null;
    if (this.freedataCode) {
      let base: any = this.model.freedataEngine.getFreeData(this.freedataCode);
      if (!!base) {
        result =  base as FreeDataVO;
      } 
    }
    return result;
  }

  /** gestion des widgets FD, retourne le code FD */
  public get freedataCode(): string {
    const parts: string[] = this.wco?.fdk?.split(ViewData.CONTEXT_SEPARATOR);
    if (parts && parts.length === 2) {
      return parts[0];
    }
    return null;
  }

  /** gestion des widgets FD, retourne le level du FD */
  public get freedataLevel(): number {
    const parts: string[] = this.wco?.fdk?.split(ViewData.CONTEXT_SEPARATOR);
    if (parts && parts.length === 2) {
      return Number(parts[1]);
    }
    return null;
  }

  /** partie qui sert à rien... pour contrat d'interface */
  layerIndex?: number;

  initCallback (item: GridsterItem, itemComponent: GridsterItemComponentInterface): void {
  };

  // initCallback (item: GridsterItem, itemComponent: GridsterItemComponentInterface): void {
  //   console.log('initCallback GridsterItem', item, itemComponent);
  //   this.compo = itemComponent;
  //   this.compo.height = 700;
  //   this.compo.el.style.height = "700px";
  // };

  dragEnabled?: boolean;
  resizeEnabled?: boolean;
  compactEnabled?: boolean;
  maxItemRows: number;
  minItemRows?: number;
  maxItemCols?: number;
  minItemCols?: number;
  minItemArea?: number;
  maxItemArea?: number;
  [propName: string]: any;

}

